import Component from './api/components'
import Thunder from './api/thunder'
import Sandbox from './api/sandbox'
import Functions from './api/functions'
import Transactions from './api/transactions'
import Media from './api/media'
import setupComponents from './components'
import Validator from './components/validator/validate'
import Event from './event'
import Project from './api/project'
import Env from './lib/Env'

export default {
    install: function (Vue, options) {
        // 1. add global method or property
        Vue.prototype.$component = function (ref) {
        // some logic ...
            return new Component(ref)
        }

        Vue.prototype.$project = new Project

        Vue.prototype.$sandbox = new Sandbox()

        Vue.prototype.$thunder = (env) => new Thunder(env)

        Vue.prototype.$transactions = new Transactions()

        Vue.prototype.$media = new Media()

        Vue.prototype.$functions = new Functions()

        Vue.prototype.$validator = () => {
            return new Validator()
        }

        Vue.prototype.$eventBus = new Event(
            Env.get('EVENT_SERVER_HOST'),
        )

        Vue.prototype.$isVoyager = () => {
            return /Operator/i.test(navigator.userAgent)
        }

        Vue.prototype.$env = Env;

        // setup all protokol components to be used globally
        setupComponents(Vue, options)
  }
}

